module.exports = __webpack_public_path__ + "static/media/fail.60c7a658.svg";